import { tokens } from "../tokens";

export const my = {
  [tokens.common.languageChanged]: "Bahasa telah ditukar",
  [tokens.nav.academy]: "Akademi",
  [tokens.nav.account]: "Akaun",
  [tokens.nav.analytics]: "Analitik",
  [tokens.nav.auth]: "Pengesahan",
  [tokens.nav.blog]: "Blog",
  [tokens.nav.browse]: "Semak",
  [tokens.nav.calendar]: "Kalendar",
  [tokens.nav.changelog]: "Perubahan",
  [tokens.nav.chat]: "Perbualan",
  [tokens.nav.checkout]: "Checkout",
  [tokens.nav.concepts]: "Konsep",
  [tokens.nav.contact]: "Hubungi",
  [tokens.nav.course]: "Kursus",
  [tokens.nav.create]: "Cipta",
  [tokens.nav.crypto]: "Kripto",
  [tokens.nav.customers]: "Pelanggan",
  [tokens.nav.dashboard]: "Papan Pemuka",
  [tokens.nav.details]: "Perincian",
  [tokens.nav.documentation]: "Dokumentasi",
  [tokens.nav.ecommerce]: "E-Dagang",
  [tokens.nav.edit]: "Edit",
  [tokens.nav.error]: "Ralat",
  [tokens.nav.feed]: "Makan",
  [tokens.nav.fileManager]: "Pengurus Fail",
  [tokens.nav.finance]: "Kewangan",
  [tokens.nav.fleet]: "Fleet",
  [tokens.nav.forgotPassword]: "Lupa Kata Laluan",
  [tokens.nav.invoiceList]: "Invois",
  [tokens.nav.jobList]: "Senarai Pekerjaan",
  [tokens.nav.kanban]: "Kanban",
  [tokens.nav.list]: "Senarai",
  [tokens.nav.login]: "Log Masuk",
  [tokens.nav.logistics]: "Logistik",
  [tokens.nav.mail]: "Mel",
  [tokens.nav.management]: "Pengurusan",
  [tokens.nav.orderList]: "Pesanan",
  [tokens.nav.overview]: "Gambaran Keseluruhan",
  [tokens.nav.pages]: "Halaman",
  [tokens.nav.postCreate]: "Cipta Pos",
  [tokens.nav.postDetails]: "Perincian Pos",
  [tokens.nav.postList]: "Senarai Pos",
  [tokens.nav.pricing]: "Harga",
  [tokens.nav.productList]: "Produk",
  [tokens.nav.profile]: "Profil",
  [tokens.nav.register]: "Daftar",
  [tokens.nav.roadmap]: "Peta Jalan",
  [tokens.nav.resetPassword]: "Tetapkan Semula Kata Laluan",
  [tokens.nav.socialMedia]: "Media Sosial",
  [tokens.nav.verifyCode]: "Sahkan Kod",
  [tokens.nav.catalog]: "Katalog",
};
